import $ from 'jquery';

/*
	Based on code By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/

function updateFileSelection({ input, $label, labelVal }) {
    let fileName = '';
    if (input.files && input.files.length > 1) {
        fileName = (input.getAttribute('data-multiple-caption') || '').replace(
            '{count}',
            input.files.length
        );
    } else if (input.value) {
        fileName = input.value.split('\\').pop();
    }

    if (fileName) {
        $label.find('[data-selected-file-name]').html(fileName);
    } else {
        $label.html(labelVal);
    }
}

$('.field-input-file').each(function () {
    const instance = {
        input: this,
        $label: $(this).next('label'),
        labelVal: $(this).next('label').html(),
    };

    $(instance.input).on('change', function (e) {
        updateFileSelection(instance);
    });

    updateFileSelection(instance);
});



// WEBPACK FOOTER //
// ./project/client/src/site__horticulture/components/forms/input-file.js